import { RequestResponse } from '../types';
import { uriParse } from '../utils';
import { openPage } from '../../nativeTools';

function nextAuth(response: RequestResponse) {
  const options = response.config;

  const url = uriParse(options.url).pathname;

  // 调用 NextJS 的 API
  if (/^\/n\//.test(url) && /\/api\//.test(url)) {
    if (/\/platform\/login/.test(response.request.responseURL)) {
      openPage(response.request.responseURL);
    }
  }

  return response;
}

export default nextAuth;
